import React, { forwardRef } from 'react';
import { TextInput as TextInputNative } from 'react-native';
import styled from 'styled-components/native';

import { getTheme } from 'lib/styles/getTheme';

const ForwardedTextInput = forwardRef<
  TextInputNative,
  React.ComponentProps<typeof TextInputNative>
>((props, ref) => <TextInputNative ref={ref} {...props} />);
ForwardedTextInput.displayName = 'ForwardedTextInput';

export const TextInput = styled(ForwardedTextInput)`
  font-family: ${getTheme('text.fontFamily')};
  font-style: italic;
`;
